/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

function onObfuscatedLinkClick (event) {
  var target = event.target;
  var level = 0;
  var maxLevel = 2;
  var selector = 'span[data-link]';

  while ((level <= maxLevel) && (!target.matches || !target.matches(selector))) {
    level++;
    target = target.parentElement;
  }

  if (level <= maxLevel) {
    if (event.type === 'mousedown') {
      preventMiddleClickScroll(event, target);
    } else {
      openObfuscatedLink(event, target);
    }
  }
}

function preventMiddleClickScroll (event, target) {
  if (event.button === 1) {
    event.preventDefault();
    event.stopPropagation();
  }
} 

function openObfuscatedLink (event, target) {
  if ((event.button !== 0) && (event.button !== 1)) {
    return;
  }
  
  var dummyLink = target || event.target;
  var url = atob(dummyLink.dataset.link);
  var target = dummyLink.getAttribute('target');
  if (!target && (event.ctrlKey || (event.type === 'auxclick'))) {
    target = '_blank';
  }

  if (target) {
    try {
      var link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
      link.setAttribute('href', url);
      link.setAttribute('target', target);
      link.setAttribute('rel', dummyLink.getAttribute('rel'));
      
      var clickEvent = new MouseEvent('click', {
        'view': window,
        'bubbles': false,
        'cancelable': true
      });
      
      link.dispatchEvent(clickEvent)
    } catch (error) {
      window.open(url, target);
    }
  } else {
    window.location.href = url;
  }
}

(function() {
    document.addEventListener('click', onObfuscatedLinkClick);
    document.addEventListener('auxclick', onObfuscatedLinkClick);
    document.addEventListener('mousedown', onObfuscatedLinkClick);
})();
